import { Injectable } from "@angular/core";
import { getApiPath } from "app/common";
import { AuthHttpService } from "app/users";
import { Observable } from "rxjs";

//auth by device
export interface TwoFactorAuthDeviceResponse {
  otp_secret: string;
  qr_code: string;
}

//auth by email
export interface TwoFactorAuthEmailResponse {
  message: boolean;
}

export type TwoFactorAuthResponse = TwoFactorAuthDeviceResponse | TwoFactorAuthEmailResponse;

@Injectable({
  providedIn: "root"
})
export class UserTwoFactorHttpService {
  constructor(private authHttp: AuthHttpService) {}

  public setUpTwoFactorAuthentication(otp_type: string): Observable<TwoFactorAuthResponse> {
    return this.authHttp.post(`${getApiPath()}accounts/two-factor-setup`, { otp_type });
  }

  public changeTwoFactorAuthentication(otp_type: string): Observable<TwoFactorAuthResponse> {
    return this.authHttp.post(`${getApiPath()}accounts/two-factor-change`, { otp_type });
  }

  public verifySetUpTwoFactorAuthentication(verify_token: string): Observable<TwoFactorAuthResponse> {
    return this.authHttp.post(`${getApiPath()}accounts/two-factor-setup-verify`, { verify_token });
  }

  public disableTwoFactorAuthentication(): Observable<TwoFactorAuthResponse> {
    return this.authHttp.post(`${getApiPath()}accounts/two-factor-disable`, {});
  }

  public disableUnconfirmedTwoFactorAuthentication(): Observable<TwoFactorAuthResponse> {
    return this.authHttp.remove(`${getApiPath()}accounts/two-factor-disable-unconfirmed`, {});
  }

  public resendTwoFactorCodeToEmail(verify_token?: string): Observable<TwoFactorAuthResponse> {
    return verify_token ? this.authHttp.post(`${getApiPath()}accounts/login-two-factor-resend-email`, { verify_token }) :
      this.authHttp.post(`${getApiPath()}accounts/two-factor-resend-email`, {});
  }

  public downloadRecoveryCodes(key: string): any {
    return this.authHttp.get(`${getApiPath()}accounts/download-recovery-codes-mobile/${key}`, {});
  }
}
